






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseUser from '@/components/compte/edit/EditBaseUser.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloUser } from '@/models/alo/AloUser'
import { AloUser } from '@/models/alo/AloUser'

@Component({
  name: 'EditPreference',    
  components:{EditBaseUser}
})
export default class EditPreference extends Vue {
      
  private user:AloUser = getDefaultAloUser()

  edit(item:AloUser) {        
    this.user = (this.$refs.baseEdit as EditBaseUser).edit(item)    
  }
  

  get configuration(){
    return this.$store.myGetters.configuration
  }
  
  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  
 
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
